"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridNotificationCloseId = exports.gridNotificationId = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const types_1 = require("../types");
const helpers_1 = require("../../helpers");
const Text_1 = require("../../Text");
const features_1 = require("../features");
const svg_1 = require("../svg");
const closeIconConfig = {
    width: helpers_1.SIZE_M,
    marginLeft: helpers_1.SPACING_S,
    marginRight: helpers_1.SPACING_M,
    padding: helpers_1.SPACING_XXS
};
const NotificationBody = (0, styled_components_1.default)(Text_1.Text) `
    width: calc(100% - ${closeIconConfig.marginLeft} - ${closeIconConfig.width});
`;
const NotificationClose = styled_components_1.default.button `
    width: ${closeIconConfig.width};
    height: ${closeIconConfig.width};
    padding: ${closeIconConfig.padding};
    margin-left: ${closeIconConfig.marginLeft};

    border: none;
    background: none;
    cursor: pointer;

    svg {
        display: block;
        width: 100%;
        height: 100%;
        color: ${({ theme }) => theme.colorControlBorder};
    }

    &:active,
    &:focus {
        outline: none;
    }
`;
const overlayCSS = (0, styled_components_1.css) `
    position: absolute;
    top: ${({ headerHeight }) => headerHeight}px;
    left: 0;
    right: 0;
    z-index: 2;
`;
const NotificationBox = styled_components_1.default.div `
    min-height: ${({ minHeight }) => minHeight}px;
    box-sizing: border-box;

    padding: ${helpers_1.SIZE_XS} ${closeIconConfig.marginRight} ${helpers_1.SIZE_XS} ${helpers_1.SPACING_S};
    position: relative;
    ${({ isOverlay }) => isOverlay && overlayCSS};

    display: flex;
    align-items: center;
    justify-content: flex-start;

    ${({ theme }) => (0, styled_components_1.css) `
        background-color: ${theme.colorHighlightNotification};
        border-bottom: ${helpers_1.BASE_BORDER_WIDTH} solid ${theme.colorBorderGrid};
    `}
`;
exports.gridNotificationId = 'grid-notification';
exports.gridNotificationCloseId = 'grid-notification-close';
const GridNotification = () => {
    const { state: { notification, rowHeight, headerHeight } } = (0, features_1.useGridContext)();
    if (notification === null || notification === void 0 ? void 0 : notification.isShown) {
        return (react_1.default.createElement(NotificationBox, { "data-selector-id": exports.gridNotificationId, headerHeight: headerHeight, minHeight: rowHeight, isOverlay: (notification === null || notification === void 0 ? void 0 : notification.position) === types_1.GRID_NOTIFICATION_POSITION.overlay },
            react_1.default.createElement(NotificationBody, null, notification.renderContent()),
            notification.onRequestClose && (react_1.default.createElement(NotificationClose, { "data-selector-id": exports.gridNotificationCloseId, onClick: notification.onRequestClose },
                react_1.default.createElement(svg_1.Close, null)))));
    }
    return null;
};
exports.default = GridNotification;
//# sourceMappingURL=GridNotification.js.map